/* tslint:disable */
/* eslint-disable */
/**
 * Ship to ship api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfigurationRequestSchema,
  ConfigurationResponseSchema,
  HTTPValidationError,
  PageConfigurationResponseSchema,
} from '../models';
import {
    ConfigurationRequestSchemaFromJSON,
    ConfigurationRequestSchemaToJSON,
    ConfigurationResponseSchemaFromJSON,
    ConfigurationResponseSchemaToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PageConfigurationResponseSchemaFromJSON,
    PageConfigurationResponseSchemaToJSON,
} from '../models';

export interface CreateConfigurationConfigurationsPostRequest {
    configurationRequestSchema: ConfigurationRequestSchema;
}

export interface DeleteConfigurationConfigurationsIdDeleteRequest {
    id: number;
}

export interface GetConfigurationConfigurationsIdGetRequest {
    id: number;
}

export interface GetConfigurationsConfigurationsGetRequest {
    page?: number;
    size?: number;
}

export interface UpdateConfigurationConfigurationsIdPutRequest {
    id: number;
    configurationRequestSchema: ConfigurationRequestSchema;
}

/**
 * 
 */
export class ConfigurationsApi extends runtime.BaseAPI {

    /**
     * Create Configuration
     */
    async createConfigurationConfigurationsPostRaw(requestParameters: CreateConfigurationConfigurationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponseSchema>> {
        if (requestParameters.configurationRequestSchema === null || requestParameters.configurationRequestSchema === undefined) {
            throw new runtime.RequiredError('configurationRequestSchema','Required parameter requestParameters.configurationRequestSchema was null or undefined when calling createConfigurationConfigurationsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-remote-user"] = this.configuration.apiKey("x-remote-user"); // x-remote-user authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Aisweb-Session"] = this.configuration.apiKey("Aisweb-Session"); // Aisweb-Session authentication
        }

        const response = await this.request({
            path: `/configurations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfigurationRequestSchemaToJSON(requestParameters.configurationRequestSchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationResponseSchemaFromJSON(jsonValue));
    }

    /**
     * Create Configuration
     */
    async createConfigurationConfigurationsPost(requestParameters: CreateConfigurationConfigurationsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponseSchema> {
        const response = await this.createConfigurationConfigurationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete Configuration
     */
    async deleteConfigurationConfigurationsIdDeleteRaw(requestParameters: DeleteConfigurationConfigurationsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteConfigurationConfigurationsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-remote-user"] = this.configuration.apiKey("x-remote-user"); // x-remote-user authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Aisweb-Session"] = this.configuration.apiKey("Aisweb-Session"); // Aisweb-Session authentication
        }

        const response = await this.request({
            path: `/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete Configuration
     */
    async deleteConfigurationConfigurationsIdDelete(requestParameters: DeleteConfigurationConfigurationsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteConfigurationConfigurationsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     * Get Configuration
     */
    async getConfigurationConfigurationsIdGetRaw(requestParameters: GetConfigurationConfigurationsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponseSchema>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getConfigurationConfigurationsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-remote-user"] = this.configuration.apiKey("x-remote-user"); // x-remote-user authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Aisweb-Session"] = this.configuration.apiKey("Aisweb-Session"); // Aisweb-Session authentication
        }

        const response = await this.request({
            path: `/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationResponseSchemaFromJSON(jsonValue));
    }

    /**
     * Get Configuration
     */
    async getConfigurationConfigurationsIdGet(requestParameters: GetConfigurationConfigurationsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponseSchema> {
        const response = await this.getConfigurationConfigurationsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Configurations
     */
    async getConfigurationsConfigurationsGetRaw(requestParameters: GetConfigurationsConfigurationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageConfigurationResponseSchema>> {
        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-remote-user"] = this.configuration.apiKey("x-remote-user"); // x-remote-user authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Aisweb-Session"] = this.configuration.apiKey("Aisweb-Session"); // Aisweb-Session authentication
        }

        const response = await this.request({
            path: `/configurations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageConfigurationResponseSchemaFromJSON(jsonValue));
    }

    /**
     * Get Configurations
     */
    async getConfigurationsConfigurationsGet(requestParameters: GetConfigurationsConfigurationsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageConfigurationResponseSchema> {
        const response = await this.getConfigurationsConfigurationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Configuration
     */
    async updateConfigurationConfigurationsIdPutRaw(requestParameters: UpdateConfigurationConfigurationsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationResponseSchema>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateConfigurationConfigurationsIdPut.');
        }

        if (requestParameters.configurationRequestSchema === null || requestParameters.configurationRequestSchema === undefined) {
            throw new runtime.RequiredError('configurationRequestSchema','Required parameter requestParameters.configurationRequestSchema was null or undefined when calling updateConfigurationConfigurationsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-remote-user"] = this.configuration.apiKey("x-remote-user"); // x-remote-user authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Aisweb-Session"] = this.configuration.apiKey("Aisweb-Session"); // Aisweb-Session authentication
        }

        const response = await this.request({
            path: `/configurations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ConfigurationRequestSchemaToJSON(requestParameters.configurationRequestSchema),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationResponseSchemaFromJSON(jsonValue));
    }

    /**
     * Update Configuration
     */
    async updateConfigurationConfigurationsIdPut(requestParameters: UpdateConfigurationConfigurationsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationResponseSchema> {
        const response = await this.updateConfigurationConfigurationsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
